module.exports = __webpack_public_path__ + "img/img-scene-1.23658683.jpg";